import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CampaignPreviewData } from 'app/campaign/campaign-overview/campaign-preview/campaign-preview-models';
import { OnsiteCampaignType } from 'app/campaign/campaign.model';
import WidgetComponentHelpers from '../../campaign/widget-component-helpers';

@Component({
  selector: 'app-variant-widget',
  templateUrl: 'variant-widget.component.html',
  styleUrls: ['variant-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VariantWidgetComponent {
  @Input() data: CampaignPreviewData;
  @Output() previewWidget = new EventEmitter();
  public CampaignTypes = OnsiteCampaignType;

  public hasValidStep(widget): boolean {
    return WidgetComponentHelpers.hasValidStep(widget);
  }
}
